<style scoped lang="scss" type="text/scss">
    .tip-placeholder {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        justify-content: center;
        color: #AAA;
        transition: all .2s;

        &.reversed {
            background-color: #F4F4F4;
        }

        .icon {
            font-size: 1.8rem;
        }

        .text {
            line-height: 1rem;
            font-size: .75rem;
            margin-top: .5rem;
        }
    }
</style>

<template>
    <div class="tip-placeholder" :class="{'reversed': true === reversed}">
        <i class="icon">&#xe6ed;</i>
        <span class="text">点击此处上传{{ title }}</span>
    </div>
</template>

<script>
    export default {
        name: '',
        props: {
            reversed: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: false
            }
        },
        data () {
            return {};
        }
    };
</script>
